
export const numberToReal = numero => {
  var numero = Number(numero);
  numero = numero.toFixed(2).split('.');
  numero[0] = 'R$ ' + numero[0].split(/(?=(?:...)*$)/).join('.');
  return numero.join(',');
};

export const realToNumber = real => {
  let onlyNumbers = real.replace(/\D/g, '');
  onlyNumbers = onlyNumbers.slice(0, onlyNumbers.length - 2) + '.' + onlyNumbers.slice(onlyNumbers.length - 2);
  return Number(onlyNumbers);
};

export const getBrazilianDateString = (date) => {
  if (typeof date === 'object') {
    return getBrazilianDateFormatFromDate(date);
  } else {
    return getBrazilianDateFormatFromString(date);
  }
};

const getBrazilianDateFormatFromDate = (date) => {
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1; // Months start at 0!
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  return dd + '/' + mm + '/' + yyyy;
};

const getBrazilianDateFormatFromString = (date) => {
  const yyyymmdd = date.split('-');
  const yyyy = yyyymmdd[0];
  const mm = yyyymmdd[1];
  const dd = yyyymmdd[2];

  return dd + '/' + mm + '/' + yyyy;
};


export const querySearch = (key) => {
  
  const defaultSearch = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  }
  
  const customSearch = (key) => {
    const search = window.location.href.split("?");
    if (search.length != 2)
      return undefined
      
    const queryParams = search[1];
    const urlParams = new URLSearchParams(queryParams)
    return urlParams.get(key);
  }
  
  return defaultSearch(key) ? defaultSearch(key) : customSearch(key); 
};
